<p>show-image works!</p>
